"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

require("./_style.scss");

function DropdownSelectedLabel(_ref) {
  var selectedValue = _ref.selectedValue,
      placeholder = _ref.placeholder;
  var hasSelectedValue = selectedValue !== undefined;
  var selectedLabelClass = 'nstyle-dd__selected';
  var text = !hasSelectedValue ? placeholder : selectedValue;
  var classes = "".concat(selectedLabelClass, " ").concat(!hasSelectedValue ? "".concat(selectedLabelClass, "--placeholder") : '');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes
  }, text);
}

var _default = DropdownSelectedLabel;
exports["default"] = _default;